<template>
    <div class="container-fluid form-container elighting-certificate-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    E-lighting Certificate
                </h1>
            </div>
        </div>
        <form
            action=""
            class="elighting-certificate"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                :errors="errors"
                                name="customer_id"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                :errors="errors"
                                name="site_id"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="doc_no">Docket No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Docket No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="doc_no"
                            />
                        </div>
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="responsible_person">Site Responsible Person</label>
                            <input
                                type="text"
                                id="responsible_person"
                                name="responsible_person"
                                v-model="form.responsible_person"
                                placeholder="Site Responsible Person"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="responsible_person"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="test_date">Test Date</label>
                            <date-picker
                                v-model="form.test_date"
                                id="test_date"
                                :options="{format: 'L'}"
                                required
                                @input="testDateChanged"
                            />
                            <error
                                :errors="errors"
                                name="test_date"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="expire_date">Expire Date</label>
                            <date-picker
                                v-model="form.expire_date"
                                id="expire_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="expire_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label>Details of system mode of operation:</label>
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="lights_non_maintained">Non-maintained</label>
                            <input
                                type="number"
                                step="1"
                                min="0"
                                id="lights_non_maintained"
                                name="lights_non_maintained"
                                v-model="form.lights_non_maintained"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="lights_non_maintained"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="lights_maintained">Maintained</label>
                            <input
                                type="number"
                                step="1"
                                min="0"
                                id="lights_maintained"
                                name="lights_maintained"
                                v-model="form.lights_maintained"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="lights_maintained"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="test_duration">Duration of system test</label>
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                id="test_duration"
                                name="test_duration"
                                v-model="form.test_duration"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="test_duration"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="automatic_test">Is automatic test system fitted Y/N</label>
                            <input
                                type="text"
                                id="automatic_test"
                                name="automatic_test"
                                v-model="form.automatic_test"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="automatic_test"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_notified">Need for repair of system notified</label>
                            <input
                                type="text"
                                id="system_notified"
                                name="system_notified"
                                v-model="form.system_notified"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="system_notified"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_notified">Need for safeguarding premises notified</label>
                            <input
                                type="text"
                                id="premises_notified"
                                name="system_notified"
                                v-model="form.premises_notified"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="premises_notified"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <p>Competent Engineer responsible for Annual Test:</p>
                    <div class="row">
                        <div class="col-sm-8">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit'"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit'"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import AuthService from "../../services/AuthService";
import FormService from "../../services/FormService";
import JobService from "../../services/JobService";
import UsersService from "../../services/UsersService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";

export default {
    components: {
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        UsesFormRouteQuery,
    ],
    props: {
        formId: {
            type: [String, Number],
            default: () => null
        },
    },
    data: function () {
        return {
            officeStaff: [],
            changed: false,
            sites: [],
            customerSignature: null,
            jobs: [],
            form: {
                type: "elighting_certificate",
                customer: {
                    company_name: "",
                },
                job_id: null,
                site_id: '',
                test_duration: 1,
                test_date: moment(),
                expire_date: moment().add(12, 'months'),
                engineer_sign_date: moment(),
                customer_sign_date: moment(),
            },
            materials: [],
            token: null,
        };
    },
    computed: {
        canDelete: function () {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
    },
    mounted: function () {

        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }

        this.getOfficeStaff();

        if (typeof this.$route.query.elighting_form !== 'undefined') {
            this.loadElightingForm(this.$route.query.elighting_form);
        }

        if (!this.form.engineer_sign_date) {
            this.form.engineer_sign_date = moment();
        }
    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = res.data;
                this.getJobs();
                if ((res.data.engineer_sign_date)) {
                    this.form.engineer_sign_date = moment(res.data.engineer_sign_date);
                } else {
                    this.form.engineer_sign_date = moment();
                }
                if (res.data.customer_sign_date) {
                    this.form.customer_sign_date = moment(res.data.customer_sign_date);
                } else {
                    this.form.customer_sign_date = moment();
                }
                if (res.data.test_date) {
                    this.form.test_date = moment(res.data.test_date);
                } else {
                    this.form.test_date = moment();
                }
                if (res.data.expire_date) {
                    this.form.expire_date = moment(res.data.expire_date);
                } else {
                    this.form.expire_date = this.form.test_date.clone().add(12, 'months');
                }
            }).catch(() => {
                this.setErrorMessage('Could not load form');
            }).then(() => {
                this.clearLoading();
            });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                }
            } else {
                this.form.site_id = '';
            }
            this.getJobs();
        },
        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({'filter[customer_id]': this.form.customer_id}).then(res => {
                this.jobs = res.data.data || [];
            }).catch(() => {
                this.showErrorMessage('Error: Could not load customer jobs');
                this.jobs = [];
            });
        },
        saveForm: function () {
            this.setSaving();
            this.clearErrors();

            if (this.$refs.customerSignature && !this.$refs.customerSignature.isEmpty()) {
                this.form.customer_signature = this.$refs.customerSignature.toPng();
            }
            this.form.materials = this.materials;

            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.form.id) {
                Service.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    }).catch(err => {
                    this.clearSaving();
                    this.captureRequestErrors(err);
                });
            } else {
                Service.create(data).then(
                    res => {
                        this.setInfoMessage("Form saved successfully");
                        this.clearSaving();
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        // TODO: Redirect to relavant page
                        this.$router.push({name: 'office.forms.search'});
                    },
                    error => {
                        this.setErrorMessage("Error: Could not delete this form");
                        console.error(error);
                    }
                );
            }
        },

        getOfficeStaff: function () {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    xhr => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        engineerNameChanged: function () {
            var name = this.form.engineer_sign_name;
            var signature = '';
            var nameArray = name.split(' ');
            if (nameArray.length > 1) {
                signature += nameArray[0][0];
                signature += nameArray[1];
            } else {
                signature = name;
            }
            if (signature) {
                this.form.engineer_signature_text = signature;
            }
        },

        forceUpdate: function () {
            this.$forceUpdate();
        },

        loadElightingForm: function (form_id) {
            this.setLoading();
            this.form.elighting_form_id = form_id;
            FormService.get(form_id).then(xhr => {
                const testForm = xhr.data;
                this.form.customer = testForm.customer;
                this.form.customer_id = testForm.customer_id;
                this.form.site_id = testForm.site_id;
                if (testForm.engineer_sign_date) {
                    this.form.test_date = moment(testForm.engineer_sign_date);
                    this.form.expire_date = moment(this.form.test_date).add(12, 'months');
                }
                this.form.engineer_signature_text = testForm.engineer_signature_text;
                this.form.engineer_sign_name = testForm.engineer_sign_name;
                this.form.engineer_id = testForm.engineer_id;
                this.form.responsible_person = testForm.customer_sign_name;
                this.form.lights_maintained = testForm.lights_maintained;
                this.form.lights_non_maintained = testForm.lights_non_maintained;
                this.form.system_notified = testForm.lights_failed;
            }, () => {
                this.setErrorMessage('Could not load original form');
            }).then(() => {
                this.clearLoading();
            });
        },

        testDateChanged() {
            this.form.expire_date = this.form.test_date.clone().add(12, 'months');
        },
    }
}
</script>
<style lang="scss">
    .lighting-table {
        .th {
            vertical-align: text-top;
        }
        .td {
            padding: 5px 2px;

            &-sw-no {
                width: 6.6rem;
            }
            &-light-no {
                width: 6rem;
            }
            &-maintained {
                width: 4rem;
                text-align: center;

                input {
                    width: auto;
                    display: inline-block;
                }
            }
            &-type {
                width: 7rem;
            }
            &-buttons {
                width: 2rem;
            }

            &-tested {
                width: 10rem;
                text-align: center;
            }
        }

        .button-radio {
            display: inline-block;
            margin: 0 1px;

            input {
                display: none
            }

            &-text {
                display: block;
                padding: 5px;
                background: #eeeeee;
                border-radius: 3px;
                text-align: center;
                width: auto;
                cursor: pointer;

                &:hover {
                    background: #a8a8a8
                }
            }

            input[type="radio"]:checked + .button-radio-text {
                background: #17a2b8;
                color: #ffffff;
            }

            input[type="radio"]:checked + .button-radio-text--failed {
                background: #b84f37;
                color: #ffffff;
            }
        }
    }

    .light-count {
        margin-right: 1em;
        text-decoration: underline;
    }
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/ELightingCertificateComponent.vue